import React from "react";
import { Order } from "types/interfaces";
import emptyData from "data/empty/order.json";
import { Link } from "react-router-dom";

interface EntryCardUserProps {
  data: Order;
}

const EntryCardUser: React.FC<EntryCardUserProps> = ({ data = emptyData }) => {
  return (
    <Link
      to={`/transaction/${data._id}`}
      className="shadow-lg py-6 px-10 rounded-lg flex flex-col sm:flex-row justify-between ring-2 ring-primary-6000"
    >
      <div className="flex items-center">
        <div className="bg-primary-6000 rounded-full w-12 h-12 mr-3">
          <img
            src={data.product.images[0]}
            alt={data.product.name}
            className={`inset-0 w-full h-full object-cover rounded-full`}
          ></img>
        </div>
        <p className="font-semibold text-lg">{data.product.name}</p>
      </div>
      <div className="flex flex-col items-left">
        <p className="font-semibold text-base">{data.profile.displayName}</p>
        <span className="text-sm">{data.pickUpLocation}</span>
      </div>
      <span className=" font-semibold text-lg">{data.status}</span>
    </Link>
  );
};

export default EntryCardUser;
